export const defaultValues = {
  regionalId: null,
  requestDate: new Date(),
  chargeRequestedId: null,
  processId: null,
  requestUser: null,
  chargeApplicantId: null,
  amount: 0,
  replaceUser: null,
  retirementReason: null,
  requestReason: null,
  retirementDate: null,
  admissionDate: null,
  contractType: null,
  observations: null,
};

export const defaultSearchValues = {
  requisitionNumber: null,
  initDate: null,
  regional: null,
  chargeRequested: null,
  requestUser: null,
  endDate: null,
  status: null,
};

export const headers = {
  initialHeaders: [
    { title: "NÚMERO DE REQUISICIÓN", field: "requisition", child: null },
    { title: "FECHA DE SOLICITUD", field: "requestDate", child: null },
    { title: "NOMBRE DE REGIONAL", field: "regional", child: "name" },
    {
      title: "CARGO SOLICITADO",
      field: "chargeRequested",
      child: "denomination",
    },
    {
      title: "NOMBRE DEL JEFE SOLICITANTE",
      field: "requestUser",
      child: null,
    },
  ],
  otherHeaders: [
    { title: "ESTADO", field: "status", child: null },
    { title: "PROCESO", field: "process", child: "description" },
    {
      title: "CARGO DEL SOLICITANTE",
      field: "chargeApplicant",
      child: "denomination",
    },
    {
      title: "TIPO DE CONTRATO",
      field: "contractType",
      child: null,
    },
    { title: "OBSERVACIONES", field: "observations", child: null },
    { title: "CANTIDAD", field: "amount", child: null },
    { title: "MOTIVO DEL RETIRO", field: "retirementReason", child: null },
    { title: "MOTIVO DE SOLICITUD", field: "requestReason", child: null },
    { title: "FECHA DE RETIRO", field: "retirementDate", child: null },
    {
      title: "FECHA OPORTUNA DE INGRESO",
      field: "admissionDate",
      child: null,
    },
    {
      title: "NOMBRE PERSONA A REEMPLAZAR",
      field: "replaceUser",
      child: null,
    },
  ],
};

export const amountValues = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
];
